<template>
  <div style="width: 1200px">
    <Table border :data="data" :columns="columns">
      <template slot-scope="{ row, index }" slot="type">
        <span :title="row.type == 1 ? '应付款' + row.payAmount : ''">{{
          row.type2
        }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="receiveAmount">
        <span
          :title="row.unusual ? '应付：' + row.payAmount + '，大于应收' : ''"
          style="margin-right: 4px"
          :class="{ unusual: row.unusual }"
          >{{ row.receiveAmount }}</span
        >
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <a style="margin-right: 4px" @click="openList(row)">{{
          row.receiveAmountReal
        }}</a>
        <a @click="openShishou(row)" type="primary">添加</a>
      </template>
      <template slot-scope="{ row, index }" slot="leaderComment">
        <Button
          size="small"
          v-if="row.leaderComment == null"
          @click="openYijian(row, index)"
          >添加</Button
        >
        <span v-else>{{ row.leaderComment }}</span>
      </template>
    </Table>
    <form-model title="实收账款" width="400" ref="shishou">
      <Button slot="btn" type="primary" @click="addShishou">提交保存</Button>
    </form-model>
    <form-model title="领导意见" width="400" ref="yijian">
      <Button slot="btn" type="primary" @click="yijian">提交意见</Button>
    </form-model>
    <Modal title="收入记录" fullscreen v-model="otable" footer-hide>
      <shouzhijilu ref="shouzhijilu"></shouzhijilu>
    </Modal>
  </div>
</template>
<script>
var taizhang = [];
import shouzhijilu from "./shouzhijiluList.vue";
export default {
  props: ["columns", "data"],
  components: { shouzhijilu },
  data() {
    return {
      otable: false,
      shishouItem: {
        tallyAccountId: "", //台账账户ID
        money: 0,
        ordersChargesId: 0, //订单收费项目记录id
        accountDate: Date.now(), //实际到账日期
        fileUrl: "",
        fileUrlArr: [],
        voucherType: 0, //类别 0--收入 -1支出
      },
      shishouForms: [
        {
          title: "台账",
          key: "tallyAccountId",
          type: "Select",
          selectType: "obj",
          required: true,
          selectItems: taizhang,
          span: 24,
        },
        {
          title: "金额",
          key: "money",
          type: "InputNumber",
          required: true,
          readonly: true,
          span: 24,
        },
        {
          title: "到账日期",
          key: "accountDate",
          type: "lyyymmdd",
          required: true,
          span: 24,
        },
        {
          title: "附件",
          key: "fileUrlArr",
          type: "lyPhoto",
          span: 24,
        },
      ],
      searchItem: {
        pageNumber: 1,
        keyWork: "",
        pageSize: 100,
      },
      yijianItem: {
        ordersChargesId: 0,
        leaderComment: "",
      },
      yijianForms: [
        {
          title: "领导意见",
          key: "leaderComment",
          type: "Input",
          span: 24,
        },
      ],
    };
  },
  methods: {
    openShishou(row) {
      this.shishouItem.ordersChargesId = row.id;
      this.shishouItem.money = row.receiveAmount;
      this.$refs.shishou.reach(this.shishouForms, this.shishouItem);
      this.getTaizhang();
    },
    addShishou() {
      //fileUrlArr
      var a = this.$refs.shishou.getItem();
      if (!a) {
        return;
      }
      this.shishouItem.fileUrl = this.utils.jsonToStr(
        this.shishouItem.fileUrlArr
      );

      this.axios({
        method: "post",
        url:
          this.axios.ipPort + "/cloud-tms-server-fms/tallyBook/addReceiveable",
        data: this.shishouItem,
      }).then((res) => {
        if (res) {
          this.$refs.shishou.close();
          this.$emit("finish", 234);
        }
      });
    },
    getTaizhang() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/tallyAccount/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        taizhang.length = 0;
        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          taizhang.push(obj);
        }
      });
    },
    openList(row) {
      console.log(row);
      this.otable = true;
      var t = {
        ono: row.ono,
        voucherType: 0,
        id: row.id,
      };
      this.$refs.shouzhijilu.reach(t);
    },
    openYijian(v) {
      this.yijianItem.ordersChargesId = v.id;
      this.$refs.yijian.reach(this.yijianForms, this.yijianItem);
    },
    yijian(v) {
      var a = this.$refs.yijian.getItem();
      if (!a) {
        return;
      }
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-fms/accountsReceivable/updateLeaderComment",
        data: this.yijianItem,
      }).then((res) => {
        if (res) {
          this.$refs.yijian.close();
          this.$emit("finish", 234);
        }
      });
    },
  },
};
</script>
<style lang="">
.unusual {
  background: red;
  color: #fff;
  padding: 2px 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/yingshouChildList.vue